import { Component } from 'react';
import Button from '../shared/button.jsx';

export default class RecurringNudge extends Component {
  render() {
    return (
      <div className="recurring-nudge active">
        <p className="recurring-nudge-text">
          Thank you for becoming a member of The Marshall Project. Showing your
          support through a monthly donation makes our future more secure, which
          means that we can continue to publish journalism with impact.
        </p>
        <p className="recurring-nudge-text">
          Would you please consider a monthly contribution to sustain our work?
        </p>
        <div className="next-button-container">
          <Button
            onClick={this.props.onAgree}
            text={`Give $${this.props.recurringAmount} Monthly`}
            className="btn-small"
          />
          <Button
            onClick={this.props.onDecline}
            text={`Give ${this.props.amount && '$' + this.props.amount} Once`}
            className="btn-small btn-secondary"
          />
        </div>
      </div>
    );
  }
}
